import { render, staticRenderFns } from "./shouke-btn.vue?vue&type=template&id=4d475e60&scoped=true"
import script from "./shouke-btn.vue?vue&type=script&lang=ts"
export * from "./shouke-btn.vue?vue&type=script&lang=ts"
import style0 from "./shouke-btn.vue?vue&type=style&index=0&id=4d475e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d475e60",
  null
  
)

export default component.exports